import { navigate as navigator } from '../router/history';
import { useUserProfile } from '../../providers/user-provider';
import { useConfig } from '../../providers/config-provider';
import { getRegionFromPath } from '../../utils/regionUtils';

export const useRouter = () => {
  const userContext = useUserProfile();
  const { config } = useConfig();
  const mappingRules = config?.rules?.mappingRules;

  const pathRegion = `/${getRegionFromPath()}`;

  let userRegion: string;

  if (userContext) {
    const { userProfile } = userContext;
    userRegion = userProfile?.region as string;
  }

  const checkTargetSelf = (region: any) => {
    const mappedRegion = getMappedRegion(region);
    if (mappedRegion?.target === '_self') {
      window.location.href = `${mappedRegion?.path}`;
      return;
    }
    const url = `${mappedRegion?.target}${mappedRegion?.path}`;
    window.location.href = url;
  };

  const pathBuilder = (path?: any, region?: any) => {
    let mappedRegion;
    if (userRegion) {
      mappedRegion = getMappedRegion(userRegion);
    } else {
      if (region) {
        mappedRegion = getMappedRegion(region);
      } else {
        mappedRegion = mappingRules?.find(
          rule => rule?.path?.toLocaleLowerCase() === pathRegion?.toLocaleLowerCase(),
        );
      }
    }
    // const page = window.location.pathname.split("/")[2]
    // if (!userRegion && page && !path) {
    //   path = '/' + page;
    // }
    let builtURL;
    if (mappedRegion && mappedRegion?.path) {
      builtURL = `${mappedRegion?.path}${path && path !== '/' ? path : ''}`;
    } else {
      builtURL = `/${path}`;
    }
    return builtURL;
  };

  const getMappedRegion = (matcher: string) => {
    const mappedRegion = mappingRules?.find(
      rule => rule?.regionCode?.toLocaleLowerCase() === matcher?.toLocaleLowerCase(),
    );
    return mappedRegion;
  };

  const navigate = (path?: any, region?: any, state?: any) => {
    const mappedRegion = getMappedRegion(userRegion);
    if (userRegion && pathRegion !== mappedRegion?.path && !path && !region) {
      checkTargetSelf(userRegion);
    }
    if (userRegion) {
      navigator(pathBuilder(path, region), { state });
    } else if (region) {
      checkTargetSelf(region);
    } else {
      navigator(`${pathRegion}${path ? `${path}` : ''}`, { state });
    }
  };

  const goBack = (fallbackPath = "/") => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate(fallbackPath);
    }
  };

  return { pathBuilder, navigate, checkTargetSelf, goBack };
};
